export default function PlatformIconGrid() {
  return (
    <img
      src="/images/landing-v2/features/platforms-grouped.svg"
      alt="Works with Slack, Google Meet, Zoom, Microsoft Teams, and Notion"
      className="w-full select-none"
      draggable="false"
    />
  );
}
